<template>
  <div id="app">
    <div class="container">
      <router-view />
      <vue-ins-progress-bar></vue-ins-progress-bar>
    </div>
    <CookieAcceptance></CookieAcceptance>
  </div>
</template>

<script>
import * as http from './utils/http';
const CookieAcceptance = () => import('@/components/CookieAcceptance');

export default {
  name: 'App',
  components : {
    CookieAcceptance
  },
  data () {
    return {
      menuVisible : true,
      msg: 'Welcome to your Vue.js powered Spring Boot App',
      user : null,
      sideBarActive : ''
    }
  },
  mounted () {
    this.$insProgress.finish();
  },
  created () {
    this.$insProgress.start();
    this.$router.beforeEach((to, from, next) => {
      this.$insProgress.start();
      next();
    })

    this.$router.afterEach((to, from) => {
      this.$insProgress.finish();
    })
  },
}
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

:root {
  --input-padding-x: 1.5rem;
  --input-padding-y: .75rem;
}

// body {
//   background: #007bff;
//   background: linear-gradient(to right, #967c0a, #180cafd4);
// }
</style>
